import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Table } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  Row,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import { connect } from "react-redux";
import * as XLSX from "xlsx";
import { H5, H4, Btn } from "../../AbstractElements";
import excelImg from "../../assets/images/datatable/excel.png";
import userCircle from "../../assets/images/datatable/user-circle.png";
import list from "../../assets/images/datatable/list.png";
import SvgIcon from "../../Components/Common/Component/SvgIcon";
import { formatDateAndTime } from "../../utils/helper";
import Pagination from "../Pagination";
import "../../assets/scss/pagination.css";
import receipt from "../../assets/images/datatable/receipt.png";
import icon from "../../assets/images/datatable/icon.png";
import { masterOperations } from "../../state/ducks/master";
import { customerOperations } from "../../state/ducks/customer";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import jsPDF from "jspdf";
import logo from "../../assets/images/logo/logo.png";
class CustomerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      BasicTab: "all",
      selectedData: {},
      purchaseItemsData: [],
      giftUserData: [],
      successItemsData: [],
      pendingItemsData: [],
      processingItemsData: [],
      shippedItemsData: [],
      canceledItemsData: [],
      filteredData:[],
      currentPage: 1,
      itemsPerPage: 10,
      sortedColumn: null,
      sortOrder: "asc",
      modalEmailOpen: false,
      modalNoteOpen: false,
    };
  }

  async componentDidMount() {
    // get all customer items
    const customerId = localStorage.getItem("selectedCustomerId");
    const response = await this.props.getCustomersDetails({
      customerId: customerId,
    });
    const purchaseItems = JSON.parse(response.payload[0].purchase_items);
    this.setState({
      BasicTab: "all", 
      selectedData: response.payload[0] ,
      purchaseItemsData: purchaseItems,
      filteredData: purchaseItems, // Initially show all items
    });
  }
  handleGeneratePDF = () => {
    const orderReceiptData = JSON.parse(
      localStorage.getItem("orderReceiptData")
    );
    const { selectedData } = this.state;
    const doc = new jsPDF();
    // Add Logo
    doc.addImage(logo, "PNG", 10, 30, 60, 20);
    // Add Title
    doc.setFontSize(18);
    doc.text("Order Receipt", 80, 20);
    // Customer Info
    doc.setFontSize(12);
    doc.text(`Customer Name: ${orderReceiptData.book_user_buyer_name}`, 10, 60);
    doc.text(`Address: ${selectedData.address}`, 10, 70);
    doc.text(`Order Date: ${orderReceiptData.date}`, 10, 80);
    // Order Items Table
    const items = orderReceiptData.order_items.map((item) => [
      item.order_item_name, // Item Name
      item.order_item_id, // Reference No.
      `£${parseFloat(item.price).toFixed(2)}`, // Price
    ]);
    if (items.length > 0) {
      doc.autoTable({
        startY: 100,
        head: [["Item Name", "Reference No.", "Amount"]],
        body: items,
      });
    }
    // Subtotal and Total
    const total = orderReceiptData.order_items.reduce(
      (sum, item) => sum + parseFloat(item.price),
      0
    );
    doc.text(`Total: £${total.toFixed(2)}`, 10, doc.lastAutoTable.finalY + 20);
    // Generate PDF as base64
    const pdfBase64 = doc.output("datauristring"); // Get PDF as base64 encoded string
    return pdfBase64; // Return base64 PDF to send via email
  };
  
  sendEmailWithPDF = async (e) => {
    e.preventDefault();
    try {
      const { selectedData } = this.state;
      const pdfBase64 = this.handleGeneratePDF();
      const response = await this.props.sendEmail({
        to: selectedData.user_email,
        attachment: pdfBase64,
        subject: "Order Details",
        name: selectedData.name,
      });
      if (response.status === 200) {
        this.setState((prevState) => ({
          modalEmailOpen: false,
        }));
      }
      toast.success("Email send successfully.", { autoClose: 10000 });
    } catch (err) {
      toast.error("Something went wrong.", { autoClose: 10000 });
      console.log(err);
    }
  };

  updateNotes = async (e) => {
    e.preventDefault();
    try {
      const { selectedData } = this.state;

      const response = await this.props.updateNote({
        userId: selectedData.id,
        note: selectedData.note,
      });
      if (response.status === 200) {
        this.setState((prevState) => ({
          modalNoteOpen: false,
        }));
      }
      toast.success("Notes updated successfully.", { autoClose: 10000 });
      window.open("/customers-management/customer-details/", "_self");
    } catch (err) {
      toast.error("Something went wrong.", { autoClose: 10000 });
      console.log(err);
    }
  };

  handleInput = async (e) => {
    try {
      let tid = e.target.id;
      const { selectedData } = this.state;
      switch (tid) {
        case "note":
          const note = e.target.value;
          this.setState({
            selectedData: {
              ...selectedData,
              note,
            },
          });
          break;
        default:
          console.log("No Matching target found in handleInput");
          break;
      }
    } catch (err) {
      console.log(err);
    }
  };

  generateExcelData = () => {
    const { purchaseItemsData } = this.state;
    let purchaseItems;
    if (Array.isArray(purchaseItemsData) && purchaseItemsData !== null) {
      purchaseItems = purchaseItemsData.length > 0 ? purchaseItemsData : [];
    } else {
      purchaseItems = [];
    }
    const xlsxData = [
      [
        "Item Name",
        "Reference No.",
        "Amount",
        "Status",
        "Date Time",
        "IP Address",
        "Payment Method",
        "Owner Name",
        "Buyer Name",
      ],
    ];
    purchaseItems.forEach((data) => {
      const orderItems = data.order_items;
      if (Array.isArray(orderItems)) {
        orderItems.forEach((orderItem) => {
          const dataRow = [
            orderItem.order_item_name,
            data.order_id,
            `£${parseFloat(data.amount).toFixed(2)}`,
            data.status,
            formatDateAndTime(data.date),
            data.ip_address,
            data.payment_method,
            data.book_user_owner_name,
            data.book_user_buyer_name,
          ];
          xlsxData.push(dataRow);
        });
      }
    });
    const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    return workbook;
  };

  handleDownload = () => {
    const workbook = this.generateExcelData();
    XLSX.writeFile(workbook, "customer_details.xlsx");
  };

  handleShowDetails = (data) => {
    localStorage.setItem("orderReceiptData", JSON.stringify(data));
    this.setState((prevState) => ({
      modalEmailOpen: !prevState.modalEmailOpen,
    }));
  };

  onCloseModal = () => {
    this.setState((prevState) => ({
      modalEmailOpen: false,
    }));
  };

  handleShowNotes = () => {
    this.setState((prevState) => ({
      modalNoteOpen: !prevState.modalNoteOpen,
    }));
  };

  onCloseNotesModal = () => {
    this.setState((prevState) => ({
      modalNoteOpen: false,
    }));
  };

  handleCustomerReceiptClick = (data) => {
    localStorage.setItem("orderReceiptData", JSON.stringify(data));
    window.open(
      "/customers-management/customer-details/customer-receipt/",
      "_self"
    );
  };

  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  handleTableSort = (column) => {
    const { purchaseItemsData, sortedColumn, sortOrder } = this.state;
    // Toggle the sortOrder if the same column is clicked again
    const newSortOrder =
      column === sortedColumn && sortOrder === "asc" ? "desc" : "asc";

    // Sort the data based on the selected column and sortOrder
    const sortedData = purchaseItemsData.slice().sort((a, b) => {
      if (newSortOrder === "asc") {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    this.setState({
      purchaseItemsData: sortedData,
      sortedColumn: column,
      sortOrder: newSortOrder,
    });
  };

  filterDataByStatus(status) {
    const { purchaseItemsData } = this.state;
    // Log the status value for debugging
    const filtered =
      status === "all"
        ? purchaseItemsData
        : purchaseItemsData.filter((item) => {
            console.log("Item status:", item.status); // Debugging status in item
            return item.status === status; // Ensure exact match with status
          });
    this.setState({ filteredData: filtered });
  }
  
  handleTabClick(status) {
  
    this.setState({ 
      BasicTab: status, // Update BasicTab based on status
    }, () => {
      this.filterDataByStatus(status); // Call filtering after state update
    });
  }
  render() {
    const {
      BasicTab,
      modalEmailOpen,
      modalNoteOpen,
      selectedData,
      currentPage,
      itemsPerPage,
      sortedColumn,
      sortOrder,
      filteredData,
    } = this.state;
    
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    let currentData;
    if (Array.isArray(filteredData) && filteredData !== null) {
      currentData =
      filteredData.length > 0
          ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
          : [];
    } else {
      currentData = [];
    }
    const totalPages =
      Array.isArray(filteredData) && filteredData !== null
        ? Math.ceil(filteredData.length / itemsPerPage)
        : 0;
    return (
      <Fragment>
        <ToastContainer />
        <div className="page-title">
          <Row>
            <Col xs="12">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard/">
                    <SvgIcon iconId="stroke-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link style={{ color: "#000" }} to="/customers-management/">
                    Customers
                  </Link>
                </li>
                <li className="breadcrumb-item active">Customer Details</li>
              </ol>
            </Col>
          </Row>
        </div>
        <Col sm="12" xl="12" className="xl-100">
          <Card>
            <CardHeader className="d-flex align-items-center justify-content-between">
              <H4>Customer Details</H4>
              <img
                src={excelImg}
                width="35"
                height="35"
                alt="excel"
                onClick={this.handleDownload}
              ></img>
            </CardHeader>
            <CardBody>
              <Form>
                <Row>
                  <Col md="6" style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={userCircle}
                      width="22"
                      height="22"
                      alt="user"
                      style={{ marginRight: "10px" }}
                    />
                    <H5 style={{ margin: 0 }}>{selectedData.name}</H5>
                  </Col>
                </Row>
                <Row>
                  <Col
                    md="3"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      color: "#595959",
                      marginTop: 15,
                    }}
                  >
                    <div>
                      <div className="mb-2">Name</div>
                      <div className="mb-2">Email</div>
                      <div className="mb-2">Address</div>
                      <div className="mb-2">Total Payment</div>
                      <div className="mb-2">Book User</div>
                      <div className="mb-2">Language</div>
                      <div className="mb-4">Notes</div>
                    </div>
                  </Col>
                  <Col
                    md="3"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: 15,
                    }}
                  >
                    <div>
                      <div className="mb-2">{selectedData.name}</div>
                      <div className="mb-2">{selectedData.user_email}</div>
                      <div className="mb-2">{selectedData.address}</div>
                      <div className="mb-2">
                        {parseFloat(selectedData.total_payment).toFixed(2)}
                      </div>
                      <div className="mb-2">{selectedData.book_user}</div>
                      <div className="mb-2">{selectedData.language_id}</div>
                      <div className="mb-4">
                        <Input
                          type="textarea"
                          placeholder="Notes"
                          value={selectedData.note || ""}
                          onClick={this.handleShowNotes}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Modal
                  isOpen={modalNoteOpen}
                  toggle={() => this.handleShowNotes()}
                  style={{ marginTop: "200px" }}
                >
                  <Form onSubmit={this.updateNotes}>
                    <span
                      style={{ textAlign: "right", padding: "5px" }}
                      onClick={this.onCloseNotesModal}
                    >
                      Close
                    </span>
                    <ModalBody>
                      <div
                        style={{
                          marginTop: "-10px",
                          marginBottom: "20px",
                          padding: "7px",
                          background: "#890077",
                          color: "#fff",
                          height: "30px",
                          width: "100%",
                          borderRadius: "5px",
                        }}
                      >
                        Update Notes
                      </div>
                      <Row>
                        <Col md="2"></Col>
                        <Col md="8">
                          <Label>Notes</Label>
                          <Input
                            style={{ fontSize: "10px", padding: "11px" }}
                            type="textarea"
                            id="note"
                            name="note"
                            value={selectedData.note || ""}
                            onChange={this.handleInput}
                          />
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter>
                      <Col md="4"></Col>&nbsp;&nbsp;&nbsp;&nbsp;
                      <Col>
                        <Btn attrBtn={{ color: "primary", type: "submit" }}>
                          Update
                        </Btn>
                        &nbsp;&nbsp;
                      </Col>
                    </ModalFooter>
                  </Form>
                </Modal>
              </Form>
              <Row>
                <Col md="12" style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={list}
                    width="22"
                    height="22"
                    alt="excel"
                    style={{ marginRight: "10px" }}
                  />
                  <H5 style={{ margin: 0 }}>Purchase Items</H5>
                </Col>
              </Row>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    href="#javascript"
                    className={BasicTab === "all" ? "active" : ""}
                    onClick={() => this.handleTabClick("all")}  // Filter for All items
                  >
                    All
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#javascript"
                    className={BasicTab === "wc-completed" ? "active" : ""}
                    onClick={() => this.handleTabClick("wc-completed")}  // Filter for Success
                  >
                   Completed
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#javascript"
                    className={BasicTab === "wc-pending" ? "active" : ""}
                    onClick={() => this.handleTabClick("wc-pending")}  // Filter for Pending
                  >
                    Pending
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#javascript"
                    className={BasicTab === "wc-processing" ? "active" : ""}
                    onClick={() => this.handleTabClick("wc-processing")}  // Filter for Processing
                  >
                    Processing
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#javascript"
                    className={BasicTab === "wc-shipping" ? "active" : ""}
                    onClick={() => this.handleTabClick("wc-shipping")}  // Filter for Shipping
                  >
                    Shipping
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#javascript"
                    className={BasicTab === "wc-cancelled" ? "active" : ""}
                    onClick={() => this.handleTabClick("wc-cancelled")}  // Filter for Cancelled
                  >
                    Cancelled
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={BasicTab}>
                <TabPane className="fade show" tabId="all">
                  <Table
                    ref="tbl"
                    striped
                    hover
                    responsive
                    bordered
                    id="data-table-zero"
                  >
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            this.handleTableSort("order_item_name")
                          }
                        >
                          Items{" "}
                          {sortedColumn === "order_item_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_buyer_name")
                          }
                        >
                          Buyer Name{" "}
                          {sortedColumn === "book_user_buyer_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_owner_name")
                          }
                        >
                          Owner Name{" "}
                          {sortedColumn === "book_user_owner_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("referenceNumber")
                          }
                        >
                          Reference No.{" "}
                          {sortedColumn === "referenceNumber" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("amount")}>
                          Amount{" "}
                          {sortedColumn === "amount" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("status")}>
                          Status{" "}
                          {sortedColumn === "status" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("date")}>
                          Date Time{" "}
                          {sortedColumn === "date" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("ip_address")}>
                          IP Address{" "}
                          {sortedColumn === "ip_address" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() => this.handleTableSort("payment_method")}
                        >
                          Payment Method{" "}
                          {sortedColumn === "payment_method" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th>Receipt</th>
                        <th>Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((data, i) =>
                        data.order_items.map((item, j) => (
                          <tr key={`${i}-${j}`}>
                            <td>{item.order_item_name}</td>
                            <td>{data.book_user_buyer_name}</td>
                            <td>{data.book_user_owner_name}</td>
                            <td>{data.order_id}</td>
                            <td>£{parseFloat(item.price).toFixed(2)}</td>
                            <td>
                              <span className="badge badge-light-primary">
                                {data.status}
                              </span>
                            </td>
                            <td>{data.date}</td>
                            <td>{data.ip_address}</td>
                            <td>{data.payment_method}</td>
                            <td>
                              <img
                                src={receipt}
                                alt="receipt"
                                height={15}
                                width={15}
                                onClick={() =>
                                  this.handleCustomerReceiptClick(data)
                                }
                              />
                            </td>
                            <td>
                              <img
                                src={icon}
                                alt="icon"
                                height={15}
                                width={15}
                                onClick={() => this.handleShowDetails(data)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </TabPane>
                <TabPane tabId="wc-completed">
                  <Table
                    ref="tbl"
                    striped
                    hover
                    responsive
                    bordered
                    id="data-table-zero"
                  >
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            this.handleTableSort("order_item_name")
                          }
                        >
                          Items{" "}
                          {sortedColumn === "order_item_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_buyer_name")
                          }
                        >
                          Buyer Name{" "}
                          {sortedColumn === "book_user_buyer_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_owner_name")
                          }
                        >
                          Owner Name{" "}
                          {sortedColumn === "book_user_owner_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("referenceNumber")
                          }
                        >
                          Reference No.{" "}
                          {sortedColumn === "referenceNumber" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("amount")}>
                          Amount{" "}
                          {sortedColumn === "amount" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("status")}>
                          Status{" "}
                          {sortedColumn === "status" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("date")}>
                          Date Time{" "}
                          {sortedColumn === "date" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("ip_address")}>
                          IP Address{" "}
                          {sortedColumn === "ip_address" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() => this.handleTableSort("payment_method")}
                        >
                          Payment Method{" "}
                          {sortedColumn === "payment_method" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th>Receipt</th>
                        <th>Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((data, i) =>
                        data.order_items.map((item, j) => (
                          <tr key={`${i}-${j}`}>
                            <td>{item.order_item_name}</td>
                            <td>{data.book_user_buyer_name}</td>
                            <td>{data.book_user_owner_name}</td>
                            <td>{data.order_id}</td>
                            <td>£{parseFloat(item.price).toFixed(2)}</td>
                            <td>
                              <span className="badge badge-light-primary"
                               style={{
                                background: "#b3ffb3",
                                color: "#00b300",
                              }}>
                                {data.status}
                              </span>
                            </td>
                            <td>{data.date}</td>
                            <td>{data.ip_address}</td>
                            <td>{data.payment_method}</td>
                            <td>
                              <img
                                src={receipt}
                                alt="receipt"
                                height={15}
                                width={15}
                                onClick={() =>
                                  this.handleCustomerReceiptClick(data)
                                }
                              />
                            </td>
                            <td>
                              <img
                                src={icon}
                                alt="icon"
                                height={15}
                                width={15}
                                onClick={() => this.handleShowDetails(data)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </TabPane>
                <TabPane tabId="wc-pending">
                  <Table
                    ref="tbl"
                    striped
                    hover
                    responsive
                    bordered
                    id="data-table-zero"
                  >
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            this.handleTableSort("order_item_name")
                          }
                        >
                          Items{" "}
                          {sortedColumn === "order_item_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_buyer_name")
                          }
                        >
                          Buyer Name{" "}
                          {sortedColumn === "book_user_buyer_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_owner_name")
                          }
                        >
                          Owner Name{" "}
                          {sortedColumn === "book_user_owner_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("referenceNumber")
                          }
                        >
                          Reference No.{" "}
                          {sortedColumn === "referenceNumber" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("amount")}>
                          Amount{" "}
                          {sortedColumn === "amount" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("status")}>
                          Status{" "}
                          {sortedColumn === "status" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("date")}>
                          Date Time{" "}
                          {sortedColumn === "date" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("ip_address")}>
                          IP Address{" "}
                          {sortedColumn === "ip_address" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() => this.handleTableSort("payment_method")}
                        >
                          Payment Method{" "}
                          {sortedColumn === "payment_method" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th>Receipt</th>
                        <th>Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((data, i) =>
                        data.order_items.map((item, j) => (
                          <tr key={`${i}-${j}`}>
                            <td>{item.order_item_name}</td>
                            <td>{data.book_user_buyer_name}</td>
                            <td>{data.book_user_owner_name}</td>
                            <td>{data.order_id}</td>
                            <td>£{parseFloat(item.price).toFixed(2)}</td>
                            <td>
                              <span className="badge badge-light-primary">
                                {data.status}
                              </span>
                            </td>
                            <td>{data.date}</td>
                            <td>{data.ip_address}</td>
                            <td>{data.payment_method}</td>
                            <td>
                              <img
                                src={receipt}
                                alt="receipt"
                                height={15}
                                width={15}
                                onClick={() =>
                                  this.handleCustomerReceiptClick(data)
                                }
                              />
                            </td>
                            <td>
                              <img
                                src={icon}
                                alt="icon"
                                height={15}
                                width={15}
                                onClick={() => this.handleShowDetails(data)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </TabPane>
                <TabPane tabId="wc-processing">
                  <Table
                    ref="tbl"
                    striped
                    hover
                    responsive
                    bordered
                    id="data-table-zero"
                  >
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            this.handleTableSort("order_item_name")
                          }
                        >
                          Items{" "}
                          {sortedColumn === "order_item_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_buyer_name")
                          }
                        >
                          Buyer Name{" "}
                          {sortedColumn === "book_user_buyer_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_owner_name")
                          }
                        >
                          Owner Name{" "}
                          {sortedColumn === "book_user_owner_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("referenceNumber")
                          }
                        >
                          Reference No.{" "}
                          {sortedColumn === "referenceNumber" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("amount")}>
                          Amount{" "}
                          {sortedColumn === "amount" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("status")}>
                          Status{" "}
                          {sortedColumn === "status" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("date")}>
                          Date Time{" "}
                          {sortedColumn === "date" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("ip_address")}>
                          IP Address{" "}
                          {sortedColumn === "ip_address" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() => this.handleTableSort("payment_method")}
                        >
                          Payment Method{" "}
                          {sortedColumn === "payment_method" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th>Receipt</th>
                        <th>Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((data, i) =>
                        data.order_items.map((item, j) => (
                          <tr key={`${i}-${j}`}>
                            <td>{item.order_item_name}</td>
                            <td>{data.book_user_buyer_name}</td>
                            <td>{data.book_user_owner_name}</td>
                            <td>{data.order_id}</td>
                            <td>£{parseFloat(item.price).toFixed(2)}</td>
                            <td>
                              <span className="badge badge-light-primary"
                               style={{
                                background: "#ffffcc",
                                color: "#808000",
                              }}>
                                {data.status}
                              </span>
                            </td>
                            <td>{data.date}</td>
                            <td>{data.ip_address}</td>
                            <td>{data.payment_method}</td>
                            <td>
                              <img
                                src={receipt}
                                alt="receipt"
                                height={15}
                                width={15}
                                onClick={() =>
                                  this.handleCustomerReceiptClick(data)
                                }
                              />
                            </td>
                            <td>
                              <img
                                src={icon}
                                alt="icon"
                                height={15}
                                width={15}
                                onClick={() => this.handleShowDetails(data)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </TabPane>
                <TabPane tabId="wc-shipping">
                  <Table
                    ref="tbl"
                    striped
                    hover
                    responsive
                    bordered
                    id="data-table-zero"
                  >
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            this.handleTableSort("order_item_name")
                          }
                        >
                          Items{" "}
                          {sortedColumn === "order_item_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_buyer_name")
                          }
                        >
                          Buyer Name{" "}
                          {sortedColumn === "book_user_buyer_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_owner_name")
                          }
                        >
                          Owner Name{" "}
                          {sortedColumn === "book_user_owner_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("referenceNumber")
                          }
                        >
                          Reference No.{" "}
                          {sortedColumn === "referenceNumber" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("amount")}>
                          Amount{" "}
                          {sortedColumn === "amount" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("status")}>
                          Status{" "}
                          {sortedColumn === "status" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("date")}>
                          Date Time{" "}
                          {sortedColumn === "date" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("ip_address")}>
                          IP Address{" "}
                          {sortedColumn === "ip_address" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() => this.handleTableSort("payment_method")}
                        >
                          Payment Method{" "}
                          {sortedColumn === "payment_method" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th>Receipt</th>
                        <th>Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((data, i) =>
                        data.order_items.map((item, j) => (
                          <tr key={`${i}-${j}`}>
                            <td>{item.order_item_name}</td>
                            <td>{data.book_user_buyer_name}</td>
                            <td>{data.book_user_owner_name}</td>
                            <td>{data.order_id}</td>
                            <td>£{parseFloat(item.price).toFixed(2)}</td>
                            <td>
                              <span className="badge badge-light-primary"  style={{
                                  background: "#ffffcc",
                                  color: "#808000",
                                }}>
                                {data.status}
                              </span>
                            </td>
                            <td>{data.date}</td>
                            <td>{data.ip_address}</td>
                            <td>{data.payment_method}</td>
                            <td>
                              <img
                                src={receipt}
                                alt="receipt"
                                height={15}
                                width={15}
                                onClick={() =>
                                  this.handleCustomerReceiptClick(data)
                                }
                              />
                            </td>
                            <td>
                              <img
                                src={icon}
                                alt="icon"
                                height={15}
                                width={15}
                                onClick={() => this.handleShowDetails(data)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </TabPane>
                <TabPane tabId="wc-cancelled">
                  <Table
                    ref="tbl"
                    striped
                    hover
                    responsive
                    bordered
                    id="data-table-zero"
                  >
                    <thead>
                      <tr>
                        <th
                          onClick={() =>
                            this.handleTableSort("order_item_name")
                          }
                        >
                          Items{" "}
                          {sortedColumn === "order_item_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_buyer_name")
                          }
                        >
                          Buyer Name{" "}
                          {sortedColumn === "book_user_buyer_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("book_user_owner_name")
                          }
                        >
                          Owner Name{" "}
                          {sortedColumn === "book_user_owner_name" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() =>
                            this.handleTableSort("referenceNumber")
                          }
                        >
                          Reference No.{" "}
                          {sortedColumn === "referenceNumber" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("amount")}>
                          Amount{" "}
                          {sortedColumn === "amount" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("status")}>
                          Status{" "}
                          {sortedColumn === "status" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("date")}>
                          Date Time{" "}
                          {sortedColumn === "date" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th onClick={() => this.handleTableSort("ip_address")}>
                          IP Address{" "}
                          {sortedColumn === "ip_address" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th
                          onClick={() => this.handleTableSort("payment_method")}
                        >
                          Payment Method{" "}
                          {sortedColumn === "payment_method" && (
                            <span>{sortOrder === "asc" ? "↑" : "↓"}</span>
                          )}
                        </th>
                        <th>Receipt</th>
                        <th>Share</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData.map((data, i) =>
                        data.order_items.map((item, j) => (
                          <tr key={`${i}-${j}`}>
                            <td>{item.order_item_name}</td>
                            <td>{data.book_user_buyer_name}</td>
                            <td>{data.book_user_owner_name}</td>
                            <td>{data.order_id}</td>
                            <td>£{parseFloat(item.price).toFixed(2)}</td>
                            <td>
                              <span className="badge badge-light-primary">
                                {data.status}
                              </span>
                            </td>
                            <td>{data.date}</td>
                            <td>{data.ip_address}</td>
                            <td>{data.payment_method}</td>
                            <td>
                              <img
                                src={receipt}
                                alt="receipt"
                                height={15}
                                width={15}
                                onClick={() =>
                                  this.handleCustomerReceiptClick(data)
                                }
                              />
                            </td>
                            <td>
                              <img
                                src={icon}
                                alt="icon"
                                height={15}
                                width={15}
                                onClick={() => this.handleShowDetails(data)}
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </TabPane>
              </TabContent>
              <Modal
                isOpen={modalEmailOpen}
                toggle={() => this.handleShowDetails()}
                style={{ marginTop: "200px" }}
              >
                <Form onSubmit={this.sendEmailWithPDF}>
                  <span
                    style={{ textAlign: "right", padding: "5px" }}
                    onClick={this.onCloseModal}
                  >
                    Close
                  </span>
                  <ModalBody>
                    <div
                      style={{
                        marginTop: "-10px",
                        marginBottom: "20px",
                        padding: "7px",
                        background: "#890077",
                        color: "#fff",
                        height: "30px",
                        width: "100%",
                        borderRadius: "5px",
                      }}
                    >
                      Send Email
                    </div>
                    <Row>
                      <Col md="2"></Col>
                      <Col md="8">
                        <Label>Email</Label>
                        <Input
                          style={{ fontSize: "10px", padding: "11px" }}
                          type="text"
                          value={selectedData.user_email}
                          disabled
                        />
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Col md="4"></Col>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Col>
                      <Btn attrBtn={{ color: "primary", type: "submit" }}>
                        Send
                      </Btn>
                      &nbsp;&nbsp;
                    </Col>
                  </ModalFooter>
                </Form>
              </Modal>
            </CardBody>
            <CardFooter>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={this.handlePageChange}
              />
            </CardFooter>
          </Card>
        </Col>
      </Fragment>
    );
  }
}
const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  getCustomersDetails: customerOperations.getCustomersDetails,
  updateNote: customerOperations.updateNote,
  sendEmail: masterOperations.sendEmail,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetails);
